module.exports = __FOREMAN_VENDOR__RC_INPUT_NUMBER__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__RC_INPUT_NUMBER__"
// module id = rc-input-number
// module chunks = 0